import { Page, H1, H2, Lead, P, UL, LegalValue, Notice, PublisherCountry } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const LegalNoticePage = () => (
  <Page testid="legal-notice-page">
    <H1>Mentions légales</H1>
    <Lead>Informations relatives à l'éditeur et à l'hébergement du service SecurePass.</Lead>

    <H2 id="editeur">Éditeur du service</H2>
    <P>
      Le service <b>{legal.serviceName}</b> est édité et exploité par <b>{legal.publisherName}</b>,
      en <PublisherCountry />.
    </P>
    <UL>
      <li>Forme juridique : <LegalValue value={legal.legalForm} /></li>
      <li>Capital social : <LegalValue value={legal.shareCapital} /></li>
      <li>RIDET : <LegalValue value={legal.ridet} /></li>
      <li>RCS : <LegalValue value={legal.rcs} /></li>
      <li>Adresse du siège : <LegalValue value={legal.registeredOffice} /></li>
    </UL>

    <H2 id="responsable">Responsable de publication</H2>
    <P><LegalValue value={legal.legalRepresentative} /></P>

    <H2 id="contact">Contact</H2>
    <UL>
      <li>E-mail : <LegalValue value={legal.contactEmail} /></li>
      <li>Téléphone : <LegalValue value={legal.phone} /></li>
    </UL>

    <H2 id="hebergement">Hébergement</H2>
    <UL>
      <li>Hébergeur : <LegalValue value={legal.hostingProvider} /></li>
      <li>Localisation de l'hébergement : <LegalValue value={legal.hostingLocation} /></li>
    </UL>

    <H2 id="propriete">Propriété intellectuelle</H2>
    <P>
      L'ensemble des éléments composant SecurePass (marque, contenus, interface, code) est protégé.
      Toute reproduction ou réutilisation sans autorisation est interdite.
    </P>

    <Notice testid="legal-notice-placeholder-note">
      Les informations marquées « à compléter » doivent être renseignées avant la mise en production ;
      aucune valeur n'est inventée.
    </Notice>
  </Page>
);

export default LegalNoticePage;
